// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"

import authAxios, { saveAccessToken, saveRefreshToken, clearAccessToken, clearRefreshToken } from "./_shared/authAxios";
import { websocketAuth, websocketDeauth } from "./_shared/ws";
import { authService } from "./_shared/authServices";
import { endpoints } from "../api/endpoints";

export const authCheck = createAsyncThunk(
  "auth/authCheck",
  async (_, { rejectWithValue }) => {
    try {
      const response = await authService.check();
      return response.data;
    } catch (err) {
      let errResp;
      if (err && err.response && err.response.data) {
        errResp = { error: err.response.data };
      } else {
        errResp = { error: err.toString() };
      }
      return rejectWithValue(errResp);
    }
  }
);

export const authLogout = createAsyncThunk(
  "auth/authLogout",
  async (_, { rejectWithValue }) => {
    try {
      await authService.logout();
      return "";
    } catch (err) {/**/ }
    return "";
  }
);

export const authLogin = createAsyncThunk(
  "auth/authLogin",
  async (action, { rejectWithValue }) => {
    try {
      const response = await authService.login(action.username, action.password);
      return response.data;
    } catch (err) {
      let errResp;
      if (err && err.response && err.response.data) {
        errResp = { error: err.response.data };
      } else {
        errResp = { error: err.toString() };
      }
      return rejectWithValue(errResp);
    }
  }
)

export const getProfile = createAsyncThunk(
  "auth/getprofile",
  async ({ userId }, { rejectWithValue }) => {
    try {
      const response = await authAxios({
        url: endpoints.user.profile + "/" + userId,
        method: "GET",
      });
      return response.data;
    } catch (err) {
      let errResp;
      if (err && err.response && err.response.data) {
        errResp = { error: err.response.data };
      } else {
        errResp = { error: err.toString() };
      }
      return rejectWithValue(errResp);
    }
  }
)

export const authSlice = createSlice({
  name: "auth",
  initialState: {
    requestActive: false,
    loggedIn: false,
    user: {},
    profile: null,
    error: ""
  },
  reducers: {
    resetAuthState: state => {
      state.loggedIn = false;
      state.user = {};
      state.profile = null;
      state.requestActive = false;
      state.error = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProfile.fulfilled, (state, action) => {
        state.profile = {};
        if (action && action.payload && action.payload.data && action.payload.data) {
          state.profile = action.payload.data;
        }
      })
      .addCase(authCheck.fulfilled, (state, action) => {
        state.requestActive = false;
        if (action && action.payload && action.payload.data && action.payload.data.user_id) {
          state.user = action.payload.data;

          localStorage.setItem("user_id", state.user.user_id);

          state.loggedIn = true;

          //websocketAuth({loggedIn: true});
        }
      })
      .addCase(authCheck.pending, (state) => {
        state.requestActive = true;
      })
      .addCase(authCheck.rejected, (state, action) => {
        if (action && action.payload && action.payload.error && action.payload.error.message) {
          state.error = action.payload.error.message;
        } else if (action && action.error && action.error.message) {
          state.error = action.error.message;
        } else {
          state.error = "Unknown error";
        }
        state.loggedIn = false;
        state.user = {};
        state.profile = null;
        state.requestActive = false;

        localStorage.removeItem("user_id");

        clearAccessToken();
        clearRefreshToken();
      })
      .addCase(authLogin.fulfilled, (state, action) => {
        state.requestActive = false;

        if (action && action.payload && action.payload.data && action.payload.data.access_token) {
          saveAccessToken(action.payload.data.access_token);
        }
        if (action && action.payload && action.payload.data && action.payload.data.refresh_token) {
          saveRefreshToken(action.payload.data.refresh_token);
        }
        if (action && action.payload && action.payload.data && action.payload.data.user_id) {
          delete action.payload.data.access_token;
          delete action.payload.data.refresh_token;
          state.user = action.payload.data;
          state.loggedIn = true;

          //websocketAuth({loggedIn: true});
          localStorage.setItem("user_id", state.user.user_id);
        }
      })
      .addCase(authLogin.pending, (state) => {
        state.requestActive = true;
        state.error = "";
      })
      .addCase(authLogin.rejected, (state, action) => {
        if (action && action.payload && action.payload.error && action.payload.error.message) {
          state.error = action.payload.error.message;
        } else if (action && action.error && action.error.message) {
          state.error = action.error.message;
        } else {
          state.error = "Unknown error";
        }
        state.loggedIn = false;
        state.user = {};
        state.requestActive = false;

        localStorage.removeItem("user_id");
      })
      .addCase(authLogout.fulfilled, (state) => {
        state.loggedIn = false;
        state.user = {};
        state.profile = null;
        state.requestActive = false;
        state.error = "";

        localStorage.removeItem("user_id");

        clearAccessToken();
        clearRefreshToken();
        websocketDeauth();
      })
  }
})

export const { resetAuthState } = authSlice.actions

export default authSlice.reducer
